import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation } from '@tanstack/react-query';

interface UseAddRelationshipParams {
  onError?: (error: ExtendedAxiosError) => void;
  onSuccess?: (data: any) => void;
}

export function useAddRelationship(options: UseAddRelationshipParams) {
  const { onError, onSuccess } = options;
  // const api = useApi();
  /* const queryClient = useQueryClient(); */

  return useMutation<any, ExtendedAxiosError, any>({
    mutationKey: ['add-relationship'],
    mutationFn: (values) =>
      new Promise((resolve) => {
        console.log(values);
        resolve(values);
      }),
    onError,
    onSuccess: async (data) => {
      /*       await queryClient.invalidateQueries({
        queryKey: [''],
      }); */
      onSuccess?.(data);
    },
  });
}
